import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {AfterMatchdayEvaluation} from "@/modules/competitions/events/AfterMatchdayEvaluation";
import {KODivision} from "@/modules/competitions/entity";
import KODivisionPromotionEvaluator from "@/modules/competitions/services/evaluators/KODivisionPromotionEvaluator";

@injectable()
export class KoDivisionPromotionEventSubscriber implements EventSubscriber {
  constructor(
    @inject(KODivisionPromotionEvaluator) protected koDivisionPromotionEvaluator: KODivisionPromotionEvaluator,
  ) {}

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterMatchdayEvaluation, callback: this.afterMatchdayEvaluation},
    ];
  }

  async afterMatchdayEvaluation(event: AfterMatchdayEvaluation): Promise<void> {
    await event.matchday.load('division');
    const division = event.matchday.division;

    if (division instanceof KODivision && division.finished) {
      await this.koDivisionPromotionEvaluator.evaluate(division);
    }
  }
}